import { render } from "./APForm.vue?vue&type=template&id=6122051f&scoped=true&lang=pug"
import script from "./APForm.vue?vue&type=script&lang=ts"
export * from "./APForm.vue?vue&type=script&lang=ts"

import "./APForm.vue?vue&type=style&index=0&id=6122051f&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-6122051f"

export default script